module.exports = __webpack_public_path__ + "static/CircularStd-BoldItalic-67ea41035cc9d3db3b738b320374161d.woff2";